"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoPlayType = exports.PublicChannelService = exports.PublicVideoService = void 0;
var video_1 = require("./video/video");
Object.defineProperty(exports, "PublicVideoService", { enumerable: true, get: function () { return video_1.PublicVideoService; } });
var channel_1 = require("./channel/channel");
Object.defineProperty(exports, "PublicChannelService", { enumerable: true, get: function () { return channel_1.PublicChannelService; } });
var globalTypes_1 = require("./generated/globalTypes");
Object.defineProperty(exports, "VideoPlayType", { enumerable: true, get: function () { return globalTypes_1.VideoPlayType; } });
//# sourceMappingURL=index.js.map